import React from 'react';
import CompanyUsersTable from '../components/CompanyUsersTable';

export function CompanyUsers() {
  return <CompanyUsersTable />;
}

export default CompanyUsers;
